import { actions, initialState } from "./state";

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actions.CHANGE_ORGANISASI:
			return {
				...state,
				organisasi: action.payload,
			};
		case actions.CHANGE_LOADING_ORGANISASI:
			return {
				...state,
				loadingOrganisasi: action.payload,
			};
		case actions.CHANGE_LOKASI:
			return {
				...state,
				lokasi: action.payload,
			};
		case actions.CHANGE_LOADING_LOKASI:
			return {
				...state,
				loadingLokasi: action.payload,
			};
		default:
			return state;
	}
};
